import { render, staticRenderFns } from "./ReverseIcon.vue?vue&type=template&id=07e09b75&"
import script from "./ReverseIcon.vue?vue&type=script&lang=ts&"
export * from "./ReverseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports